<template>
  <page>
    <sidebar slot="sidebar"/>
    <span slot="header">Bioreq Documents</span>
    <b-tabs card no-fade>
      <b-tab title="Pending" active>
        <pending ref="pending"/>
      </b-tab>
      <b-tab title="Processed">
        <processed ref="processed"/>
      </b-tab>
    </b-tabs>
  </page>
</template>

<script>
import pending from './pending'
import processed from './processed'
import page from '../../../templates/page'
import sidebar from '../../../sidebar'

export default {
  components: {
    pending,
    processed,
    sidebar,
    page
  },
  methods: {

  }
}
</script>


// WEBPACK FOOTER //
// src/components/pages/admin/bioreq/index.vue